import { Vector2 } from "three";
function sort2dObjsbyVector(objs, vector, transformerFunc = (x) => x) {
	const normV = new Vector2(...vector).normalize();
	return objs.slice().sort((a, b) => {
		const aPos = transformerFunc(a.pos);
		const bPos = transformerFunc(b.pos);
		return aPos[0] * normV.x + (aPos[2] || aPos[1]) * normV.y - (bPos[0] * normV.x + (bPos[2] || bPos[1]) * normV.y);
	});
}
export { sort2dObjsbyVector };

//# sourceMappingURL=index37.js.map